import React from "react";
import { useNavigate } from "react-router-dom";
import PageTitle from "../../layouts/PageTitle";
import { useGetCategoryExpenseSummariesQuery } from "../../../store/appApi";

const CategorySummary = () => {
  const navigate = useNavigate();

  const { data, isLoading, isFetching, isError } =
    useGetCategoryExpenseSummariesQuery();

  const rows = Array.isArray(data?.rows) ? data.rows : [];
  const grandTotal = Number(data?.grandTotal) || 0;
  const loading = isLoading || isFetching;

  const fmt = (n) => Number(n).toLocaleString("en-IN");

  return (
    <>
      <PageTitle activeMenu="Category Report" motherMenu="Finance" />

      <div className="row">
        <div className="col-lg-12">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title mb-0">Expense Summary by Category</h4>
            </div>

            <div className="card-body">
              {isError && (
                <div className="alert alert-danger">
                  Failed to load category summaries. Please try again.
                </div>
              )}

              <div className="table-responsive">
                <table className="display dataTable no-footer w-100">
                  <thead>
                    <tr>
                      {/* <th>#</th> */}
                      <th>Category Name</th>
                      <th>No. of Transactions</th>
                      <th>Total Expense (₹)</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading && (
                      <tr>
                        <td colSpan={5} className="text-center py-4">
                          <span className="spinner-border spinner-border-sm me-2" />
                          Loading…
                        </td>
                      </tr>
                    )}

                    {!loading && rows.length === 0 && !isError && (
                      <tr>
                        <td colSpan={5} className="text-center py-4 text-muted">
                          No expense data found.
                        </td>
                      </tr>
                    )}

                    {!loading &&
                      rows.map((row, idx) => (
                        <tr key={row._id || idx}>
                          {/* <td className="text-muted small">{idx + 1}</td> */}
                          <td className="fw-semibold">{row.categoryName}</td>
                          <td>{row.txnCount}</td>
                          <td className="fw-semibold text-danger">
                            ₹ {fmt(row.totalExpense)}
                          </td>
                          <td>
                            <button
                              className="btn btn-xs btn-outline-primary"
                              onClick={() =>
                                navigate(
                                  `/payments/finance/category-detail/${row._id}`,
                                )
                              }
                            >
                              View Details
                            </button>
                          </td>
                        </tr>
                      ))}

                    {/* Grand Total row */}
                    {!loading && rows.length > 0 && (
                      <tr className="table-dark fw-bold">
                        <td colSpan={3} className="text-end pe-3">
                          Grand Total
                        </td>
                        <td colSpan={2}>₹ {fmt(grandTotal)}</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CategorySummary;
